<template>
    <div class="wrapper">
        <div v-if="$route.query.type == 1" class="list-title-w"></div>
        <div v-else-if="$route.query.type == 2" class="list-title-a"></div>
        <div v-else-if="$route.query.type == 3" class="list-title-n"></div>
        <div v-else class="list-title-s"></div>
        <van-list v-model="loading" :finished="finished" finished-text="给你更多好看" @load="onLoad" class="list flex fd-c ai-c">
            <div class="item" v-for="(item, index) in list"
                @click="$router.push({ name: 'indexListDetail', query: { id: item.id, type: $route.query.id } })"
                :key="index">
                <van-image width="6.28rem" height="3.74rem" radius=".1rem" fit="cover"
                    :src="item.cover + '?x-oss-process=image/resize,w_750'">
                    <template v-slot:loading>
                        <van-loading type="spinner" size="20" />
                    </template>
                </van-image>
                <div class="item-content flex ai-c jc-sb">
                    <div style="width: 5.5rem;">
                        <div class="title lines">
                            {{ item.name }}
                        </div>
                        <div class="lb">{{ item.customer }}</div>
                    </div>
                    <div class="num">{{ item.num }}</div>
                </div>

            </div>
        </van-list>
        <van-popup v-model="show">
            <div class="box">
                <img class="bg" src="@/assets/images/address.png" alt="">
                <div class="btns flex jc-c">
                    <div @click="openLocation" class="btn"></div>
                    <div @click="telClick" class="btn"></div>
                </div>
            </div>
        </van-popup>
        <div class="haokan" @click="finished?show=true:''"></div>
    </div>
</template>

<script>
import { postPage } from '@/api'
import wx from 'weixin-js-sdk'
export default {
    components: {

    },
    props: {},
    data() {
        return {
            show: false,
            timer: null,
            Index: 0,
            page: 1,
            list: [],
            loading: false,
            finished: false,
        };
    },
    watch: {},
    computed: {},
    methods: { 
        openLocation() {
            wx.openLocation({
                latitude: 24.482326, // 纬度，浮点数，范围为90 ~ -90
                longitude: 118.174788, // 经度，浮点数，范围为180 ~ -180。
                name: '厦门市万殊网络科技有限公司', // 位置名
                address: '福建省厦门市思明区国金广场B栋6F', // 地址详情说明
                scale: 14, // 地图缩放级别,整型值,范围从1~28。默认为最大
                infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
            });
        },
        telClick() {
            window.location.href = "tel:17759205660"
        },
        onLoad() {
            this.postPage()
        },
        postPage() {
            postPage({
                page: this.page,
                limit: 20,
                type: this.$route.query.type
            }).then(res => {
                this.page++
                let list = res.data.data.records
                if (list.length == 0) {
                    this.finished = true;
                }
                
                this.list.push(...list)
                for (let i = 0; i < this.list.length; i++) {
                    let item = this.list[i];
                    let num = i + 1
                    item.num = num < 10 ? '0' + num : num
                }
                this.loading = false;
            })
        }
    },
    created() {

    },
    mounted() {
        var type = this.$route.query.type
        console.log(this.$route.query.type);
        var words = {
            '0': 'H5案例',
            '1': '动画案例',
            '2': '插画案例',
            '3': '品宣案例',
        }
        wx.ready(() => {
            var obj = {
                title: 'WANS｜' + words[type], // 分享标题
                desc: '历史不可复制，破局者得以生存', // 分享描述
                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://case.chinawans.com/img/share.jpg', // 分享图标
                success: function () {
                    // 设置成功
                }
            }
            // wx.hideOptionMenu();
            wx.updateAppMessageShareData(obj)
            wx.updateTimelineShareData(obj)
        })
        
    },
    destroyed() {
    },
};
</script>
<style scoped>
.wrapper {
    position: relative;
    width: 100%;
    min-height: 100vh;

}

.list-title-w {
    width: 6.42rem;
    height: 4.49rem;
    background-size: 100% 100%;
    margin: 0.56rem auto 0;
    background-image: url(~@/assets/images/list-title-w.png);
}

.list-title-a {
    width: 6.42rem;
    height: 4.49rem;
    background-size: 100% 100%;
    margin: 0.56rem auto 0;
    background-image: url(~@/assets/images/list-title-a.png);
}

.list-title-n {
    width: 6.42rem;
    height: 4.49rem;
    background-size: 100% 100%;
    margin: 0.56rem auto 0;
    background-image: url(~@/assets/images/list-title-n.png);
}

.list-title-s {
    width: 6.42rem;
    height: 7.52rem;
    background-size: 100% 100%;
    margin: 0.56rem auto 0;
    background-image: url(~@/assets/images/list-title-s.png);
}


.list {
    width: 100%;

}

.list .item {
    width: 6.28rem;
    margin-top: .65rem;
}

.list .item-content {
    border-bottom: .02rem solid rgba(232, 232, 232, 1);
}

.list .item .title {
    font-size: .33rem;
    font-family: OPPOSans;
    font-weight: normal;
    color: #000000;
    line-height: .45rem;
}

.list .item .lb {
    font-size: .2rem;
    font-family: OPPOSans;
    font-weight: normal;
    color: #E76D30;
    line-height: .45rem;
}

.list .item .num {
    min-width: .35rem;
    text-align: center;
    font-size: .43rem;
    font-family: OPPOSans;
    font-weight: normal;
    color: #E76D30;
    line-height: .98rem;
    background-image: url(~@/assets/images/num-bg.png);
    background-size: .35rem .51rem;
    background-position: center;
    background-repeat: no-repeat;
}

.type {
    font-size: .38rem;
    margin-right: .55rem;
    font-family: PingFangSC;
    font-weight: 200;
    color: rgba(255, 255, 255, .51);
}

.wrapper>>>.van-popup {
    background-color: #fff0;
}
.wrapper .box{
    position: relative;
}
.wrapper .btns{
    position: absolute;
    bottom: 0.8rem;
    width: 100%;
}
.wrapper .btns .btn{
    width: 1.2rem;
    height: .8rem;
}

.wrapper .bg {
    width: 4.96rem;
    height: 6.69rem;
}

.wrapper>>>.van-list__finished-text {
    position: relative;
    padding: 0 .15rem 0 .4rem;
    background: #E26F38;
    border-radius: .21rem;
    line-height: .42rem;
    margin-top: .48rem;
    font-size: .2rem;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #FFFFFF;
    margin-bottom: .2rem;
}
.wrapper>>>.van-list__finished-text::before{
    position: absolute;
    left: 0.15rem;
    top: .1rem;
    content: '';
    width: .15rem;
    height: .22rem;
    background-image: url(~@/assets/images/xr1.png);
    background-size: 100% 100%;
}
.haokan{
    position: absolute;
    left: 0;
    bottom: 0.2rem;
    width: 100vw;
    height: .5rem;
    z-index: 100;
}
</style>